/* eslint-disable */
import { useRef, useState } from "react";

export const useVideoPlayer = () => {
  const [playingVideos, setPlayingVideos] = useState(new Set());
  const videoRefs = useRef(new Map());

  const toggleVideoPlay = (index) => {
    const video = videoRefs.current.get(index);
    if (!video) return;

    if (playingVideos.has(index)) {
      video.pause();
      setPlayingVideos((prev) => {
        const newSet = new Set(prev);
        newSet.delete(index);
        return newSet;
      });
    } else {
      video.play();
      setPlayingVideos((prev) => new Set(prev).add(index));
    }
  };

  return { playingVideos, videoRefs, toggleVideoPlay };
};
